<script>
import {Bar} from 'vue-chartjs'
export default {
    extends: VueChartJs.Bar,
    props : ['labels', 'chartData', 'chartDataTrue', 'chartDataFalse'],
    mounted () {
        this.renderChart({
        labels: this.labels,
        datasets: [
            {
                label: 'Total Cluster',
                backgroundColor: ['#ff6384','#36a2eb','#ffce56','#f58231','#46f0f0','#d2f53c','#911eb4','#f032e6','#3cb44b','#ffe119','#e6194b','#fabebe','#008080','#e6beff','#0082c8','#aa6e28','#fffac8','#800000','#aaffc3','#808000','#000080','#808080'],
                data: this.chartData
            },{
                label: 'Attent Guest',
                backgroundColor: ['#ff6384','#36a2eb','#ffce56','#f58231','#46f0f0','#d2f53c','#911eb4','#f032e6','#3cb44b','#ffe119','#e6194b','#fabebe','#008080','#e6beff','#0082c8','#aa6e28','#fffac8','#800000','#aaffc3','#808000','#000080','#808080'],
                data: this.chartDataTrue
            }
        ]
        }, {responsive: true, maintainAspectRatio: false})
    }
}
</script>

<style>

</style>
